import { useRef, useEffect, useState } from 'react'
import { useParams, useLocation, useSearchParams } from 'react-router-dom'
import { useMediaQuery } from '@mui/material';
import { Helmet } from "react-helmet";
import db from "../../firebase-config"
import HeaderTumbler from '../../components/header/HeaderTumbler';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import moment from 'moment-timezone';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import targetGrey from '../../assets/img/targetGrey.png'
import timeLeft from '../../assets/img/time-left.png'
import box from '../../assets/img/box.png'
import DonutChartFGTracking from '../../components/chart/DonutChartFGTracking';
import Fist from '../../assets/img/protest.png';
import PopupFGTracking from '../../components/model/PopupFGTracking';




const Item = styled(Paper)(({ theme }) => ({
    //backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    // borderRight: '0.8px solid #c2c2c2',
    borderRadius: "0px 0px 0px 0px",
    //height: { xs: "100%", md: "100%" },

}));

const ItemBox = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(0),
    backgroundColor: 'transparent',
    textAlign: 'right',
    border: '0.8px dashed #c2c2c2',
    borderRadius: "5px 5px 5px 5px"
    //height: '102%'

}));

const box_box = [
    {
        BATCH: '-',
        BARREL_MEAT: '-'
    },
    {
        BATCH: '-',
        BARREL_MEAT: '-'
    },
    {
        BATCH: '-',
        BARREL_MEAT: '-'
    },
    {
        BATCH: '-',
        BARREL_MEAT: '-'
    },

]


const FGTrackingLine7Line8 = () => {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const colors = tokens(theme.palette.mode);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 2);
    yesterday.setHours(0, 0, 0, 0);

    const [fg_tracking_line7, setFg_tracking_line7] = useState([]);
    const [fg_tracking_line8, setFg_tracking_line8] = useState([]);
    const [fg_tracking_store_line7, setFg_tracking_store_line7] = useState([]);
    const [fg_tracking_store_line8, setFg_tracking_store_line8] = useState([]);
    const [marinate_page2, setMarinate_page2] = useState([]);
    const [current_batch_line7, setCurrent_batch_line7] = useState([]);
    const [current_batch_line8, setCurrent_batch_line8] = useState([]);

    const [connect_line7, setConnect_line7] = useState([]);
    const [connect_line8, setConnect_line8] = useState([]);

    useEffect(() => {
        const docIdLine7 = '411700000000000000Line7FG';
        const docRefLine7 = db.collection('prod_mes_ignition_fg_dashboard').doc(docIdLine7);

        const unsubscribeLine7 = docRefLine7.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setFg_tracking_line7([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setFg_tracking_line7([]);
            }
        });

        const docIdLine8 = '411700000000000000Line8FG';
        const docRefLine8 = db.collection('prod_mes_ignition_fg_dashboard').doc(docIdLine8);

        const unsubscribeLine8 = docRefLine8.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setFg_tracking_line8([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setFg_tracking_line8([]);
            }
        });

        const docIdCurrentLine7 = '4117.00000000000000.LINE7CURRENT_BATCH';
        const docRefCurrentLine7 = db.collection('prod_mes_ignition_preparation_zone_page1').doc(docIdCurrentLine7);

        const unsubscribeCurrentLine7 = docRefCurrentLine7.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setCurrent_batch_line7([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setCurrent_batch_line7([]);
            }
        });

        const docIdCurrentLine8 = '4117.00000000000000.LINE8CURRENT_BATCH';
        const docRefCurrentLine8 = db.collection('prod_mes_ignition_preparation_zone_page1').doc(docIdCurrentLine8);

        const unsubscribeCurrentLine8 = docRefCurrentLine8.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setCurrent_batch_line8([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setCurrent_batch_line8([]);
            }
        });

        const subscriberMarinationP2 = db
            .collection("prod_mes_ignition_preparation_zone_page2")
            //.where("ID", "==", "MES_Egg.4042.00000000000333.thailand.steamed_egg.meat_dispenser.line_3.0NoError")
            .onSnapshot((querySnapshot) => {
                const marinationp2Data = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setMarinate_page2(marinationp2Data);

            });

        const docIdConnectLine7 = 'Simulator.4117.00000000000000.Thailand.CW_Box.CW_Box1.Line7.Connect';
        const docRefConnectLine7 = db.collection('prod_mes_ignition_fg_dashboard_tag_list').doc(docIdConnectLine7);

        const unsubscribeConnectLine7 = docRefConnectLine7.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setConnect_line7([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setConnect_line7([]);
            }
        });

        const docIdConnectLine8 = 'Simulator.4117.00000000000000.Thailand.CW_Box.CW_Box2.Line8.Connect';
        const docRefConnectLine8 = db.collection('prod_mes_ignition_fg_dashboard_tag_list').doc(docIdConnectLine8);

        const unsubscribeConnectLine8 = docRefConnectLine8.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setConnect_line8([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setConnect_line8([]);
            }
        });

        return () => {
            unsubscribeLine7();
            unsubscribeLine8();
            unsubscribeCurrentLine7();
            unsubscribeCurrentLine8();
            subscriberMarinationP2();
            unsubscribeConnectLine7();
            unsubscribeConnectLine8();
        }
    }, []);



    const persent_chart_line7 = fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line7?.ACTUAL_BOX === 'NA' || fg_tracking_line7?.TARGET_BOX === 'NA' ? 'NA' : Math.floor((fg_tracking_line7?.ACTUAL_BOX / fg_tracking_line7?.TARGET_BOX) * 100)

    const persent_chart_line8 = fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line8?.ACTUAL_BOX ===  'NA' || fg_tracking_line8?.TARGET_BOX === 'NA' ? 'NA' : Math.floor((fg_tracking_line8?.ACTUAL_BOX / fg_tracking_line8?.TARGET_BOX) * 100)

    const ready_line7 = marinate_page2 === undefined ? '' : marinate_page2.filter(item => item.id.includes("411700000000000000LINE7"));

    const ready_line8 = marinate_page2 === undefined ? '' : marinate_page2.filter(item => item.id.includes("411700000000000000LINE8"));

    const slice_ready_line7 = ready_line7 === undefined ? '' : ready_line7.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });

    const slice_ready_line8 = ready_line8 === undefined ? '' : ready_line8.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });

    console.log(persent_chart_line7)




    return (
        <>
            <Helmet>
                <title>FG Tracking Line7-Line8| MES</title>
            </Helmet>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <HeaderTumbler
                        header={'FG Tracking'}
                    //icon={time.toString() >= '06:00:00' && time.toString() <= '18:00:00' ? <LightModeOutlinedIcon style={{ color: '#ffffff' }} /> : <DarkModeOutlinedIcon style={{ color: '#ffffff' }} />}
                    />
                </Grid>
                <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} style={{ paddingTop: 3, paddingLeft: 11, paddingRight: 3, backgroundColor: colors.neutral['black'] }}>
                    <Grid item xs={6} sx={{ borderRight: '0.8px solid #c2c2c2', position: 'relative' }}>
                        {connect_line7?.VALUE == false ? <PopupFGTracking line={'Line 7'} /> :
                            <Item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: 'transparent' }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-2vh", md: "12px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Grid item xs={5} textAlign="right" >
                                            <Typography style={{ color: "#00ca9b", fontSize: 'clamp(28px, 3vw, 48px)', fontWeight: 'bold', lineHeight: "0px" }} >
                                                Line 7&nbsp;
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} textAlign="left" >
                                            <Typography style={{ color: colors.neutral['grey'], fontSize: 'clamp(20px, 3vw, 36px)', lineHeight: "0px", paddingTop: 4, fontWeight: 'bold' }} >
                                                &nbsp;{fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? 'ไม่ตรงแผนผลิต' : fg_tracking_line7?.SKU}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} textAlign="right" >
                                            {fg_tracking_line7?.SHIFT == undefined ?  <LightModeOutlinedIcon sx={{ color: '#ffffff', height: 'clamp(10px, 6vh, 100px)', position: "relative", marginTop: { xs: "1vh", md: "12px" } }} /> : fg_tracking_line7?.SHIFT == 'D' ? <LightModeOutlinedIcon sx={{ color: '#ffffff', height: 'clamp(10px, 6vh, 100px)', position: "relative", marginTop: { xs: "1vh", md: "12px" } }} /> : <DarkModeOutlinedIcon sx={{ color: '#ffffff', height: 'clamp(10px, 6vh, 100px)', position: "relative", marginTop: { xs: "1vh", md: "12px" } }} />}
                                        </Grid>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sx={{ position: "relative", marginTop: { xs: "-1vh", md: "-1vh" } }}>
                                    <Grid container spacing={0}>
                                        {/* Block 1: */}
                                        <Grid item xs={4}>
                                            <Box sx={{ backgroundColor: '#404040', p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', }}>
                                                <img src={targetGrey} alt="target" style={{ height: '6vh', objectFit: 'contain', position: "relative", top: isMdUp ? '-0.5vh' : '-1.2vh' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 1, md: 2 } }}>
                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                        {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line7?.TARGET_WEIGHT_KG)).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 2vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                        kg
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Block 2: */}
                                        <Grid item xs={4}>
                                            <Box sx={{ backgroundColor: colors.neutral['green'], p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={Fist} alt="bulb" style={{ height: '6vh', objectFit: 'contain', position: "relative", top: isMdUp ? '-0.5vh' : '-1.2vh' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 1, md: 2 } }}>
                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                        {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line7?.ACTUAL_WEIGHT)).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 2vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                        kg
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Block 3: */}
                                        <Grid item xs={4}>
                                            <Box sx={{ backgroundColor: '#e2e2e2', p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={timeLeft} alt="person" style={{ height: '6vh', objectFit: 'contain', position: "relative", top: isMdUp ? '-0.5vh' : '-1.2vh' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 1, md: 2 } }}>
                                                    <Typography sx={{ color: '#404040', fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                    {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line7?.REMAINING_WEIGHT <= 0 ? 0 : Math.round(Number(fg_tracking_line7?.REMAINING_WEIGHT)).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: '#636363', fontSize: 'clamp(12px, 2vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                        kg
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={0}>
                                        {/* chart: */}
                                        <Grid item xs={4} sx={{ position: "relative", marginTop: { xs: "5vh", md: "1vh" } }}>
                                            <DonutChartFGTracking
                                                act={fg_tracking_line7?.WARNING == undefined ? 0 : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? 0 : fg_tracking_line7?.ACTUAL_BOX}
                                                diff={fg_tracking_line7?.WARNING == undefined ? 1 : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? 1 : fg_tracking_line7?.REMAINING_BOX < 0 ? 0 : fg_tracking_line7?.REMAINING_BOX}
                                                persent={persent_chart_line7}
                                            />
                                        </Grid>

                                        {/* std/box: */}
                                        <Grid item xs={8} >
                                            <Grid item xs={11} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "1vh", md: "1vh" } }}>
                                                <ItemBox>
                                                    <Grid container spacing={0}>
                                                        {/* Block 1: */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'left', ml: 1 }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                        STD
                                                                    </Typography>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                        /Box
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        {/* Block 2: */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', ml: 1.5 }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(14px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                                        {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line7?.STD_BAG_PER_BOX === 'NA' ? 'NA' : Math.round(Number(fg_tracking_line7?.STD_BAG_PER_BOX)).toLocaleString()}
                                                                    </Typography>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                                        bag
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        {/* Block 3: */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right', mr: 1 }}>

                                                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(14px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                                        {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line7?.STD_KG_PER_BOX}
                                                                    </Typography>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                                        kg
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </ItemBox>
                                            </Grid>
                                            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right', mr: 0.5, position: "relative", marginTop: { xs: "-0.5vh", md: "0vh" } }}>
                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(14px, 2vw, 36px)' }}>
                                                    Box
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "-4vh", md: "-2vh" } }}>
                                                <Grid container spacing={0}>
                                                    {/* target : */}
                                                    <Grid item xs={6}>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                    Target
                                                                </Typography>
                                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: 'bold' }}>
                                                                    {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line7?.TARGET_BOX === 'NA' ? 'NA' : Math.round(Number(fg_tracking_line7?.TARGET_BOX)).toLocaleString()}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>

                                                    {/* actual : */}
                                                    <Grid item xs={6}>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right' }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                    Actual
                                                                </Typography>
                                                                <Typography sx={{ color: '#00ca9b', fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: 'bold' }}>
                                                                    {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line7?.ACTUAL_BOX)).toLocaleString()}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "-4.5vh", md: "-2vh" } }}>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                        <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 28px)' }}>
                                                            Remaining
                                                        </Typography>
                                                        <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: 'bold', ml: 1 }}>
                                                        {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line7?.REMAINING_BOX <= 0 ? 0 : Math.round(Number(fg_tracking_line7?.REMAINING_BOX)).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={10} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "-2vh", md: "0vh" } }}>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right' }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'baseline',
                                                            backgroundColor: 'rgba(255, 165, 0, 0.2)', // สีส้มโปร่งแสง
                                                            px: 1, // padding แนวนอน
                                                            py: 0, // padding แนวตั้ง
                                                            borderRadius: 1,
                                                            height: 'clamp(30px, 8vh, 80px)',
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: colors.neutral['white'],
                                                                fontSize: 'clamp(12px, 3vw, 28px)',
                                                                position: "relative", top: { xs: "-2vh", md: "-.5vh" }
                                                            }}
                                                        >
                                                            Lower ({fg_tracking_line7?.WARNING == undefined ? ('-' + '%') : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line7?.REJECTION_PERCENT)).toLocaleString() + '%'})
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                color: colors.neutral['white'],
                                                                fontSize: 'clamp(28px, 3vw, 42px)',
                                                                fontWeight: 'bold',
                                                                ml: 2,
                                                                position: "relative", top: { xs: "-2vh", md: "-.5vh" }
                                                            }}
                                                        >
                                                            {fg_tracking_line7?.WARNING == undefined ? '-' : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line7?.REJECTION_BAG)).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sx={{ borderBottom: "1px solid #c2c2c2", position: "relative", marginTop: { xs: "-11.5vh", md: "3vh" } }} >

                                </Grid>

                                <Grid item xs={12}>
                                    <Grid item xs={12} >
                                        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(10px, 3vw, 38px)', fontWeight: 'bold' }}>
                                                    RM
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(10px, 3vw, 32px)' }}>
                                                    (Batch No.)
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(10px, 3vw, 32px)' }}>
                                                    &
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(12px, 3vw, 38px)', fontWeight: 'bold' }}>
                                                    Box Forecast
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(10px, 3vw, 32px)' }}>
                                                    (Box)
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>

                                </Grid>

                                <Grid item xs={12} sx={{ position: "relative", marginTop: { xs: "-2vh", md: "1vh" } }}>
                                    <Grid container spacing={0.5}>
                                        {(fg_tracking_line7?.WARNING == undefined ? box_box : fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? box_box : slice_ready_line7).map((item) => {
                                            return <Grid item xs={3}>
                                                <Box sx={{ backgroundColor: '#504c4c', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: "5px 5px 0px 0px", height: 'clamp(10px, 7vh, 80px)', }}>
                                                    <Typography sx={{ color: fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? colors.neutral['white'] : (current_batch_line7?.CURRENT_BATCH === '' ? 0 : current_batch_line7?.CURRENT_BATCH) === item.BATCH ? colors.neutral['green'] : colors.neutral['white'], fontSize: 'clamp(16px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                        {item.BATCH}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ backgroundColor: '#404040', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: "0px 0px 5px 5px" }}>
                                                    <img src={box} alt="target" style={{ height: '5vh', objectFit: 'contain' }} />
                                                    <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 0, md: 0 } }}>
                                                        <Typography sx={{ color: fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? colors.neutral['white'] : (current_batch_line7?.CURRENT_BATCH === '' ? 0 : current_batch_line7?.CURRENT_BATCH) === item.BATCH ? colors.neutral['green'] : colors.neutral['white'], fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold', ml: 0.5 }}>
                                                            {fg_tracking_line7?.WARNING == 'ไม่ตรงแผนผลิต' ? item.BARREL_MEAT : fg_tracking_line7?.STD_KG_PER_BOX === 'NA' ? 'NA' : Math.floor((((fg_tracking_line7?.FG_STD_PERCENT_MEAT_YIELD == undefined ? 0 : fg_tracking_line7?.FG_STD_PERCENT_MEAT_YIELD) * item.BARREL_MEAT) / 100) / (fg_tracking_line7?.STD_KG_PER_BOX == undefined ? 0 : fg_tracking_line7?.STD_KG_PER_BOX)).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        })
                                        }
                                    </Grid>
                                </Grid>
                            </Item>}
                    </Grid>

                    {/*Line8  */}
                    <Grid item xs={6} sx={{ position: 'relative' }}>
                        {connect_line8?.VALUE == false ? <PopupFGTracking line={'Line 8'} /> :
                            <Item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: 'transparent' }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-2vh", md: "12px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Grid item xs={5} textAlign="right" >
                                            <Typography style={{ color: "#049cd4", fontSize: 'clamp(28px, 3vw, 48px)', fontWeight: 'bold', lineHeight: "0px" }} >
                                                Line 8&nbsp;
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} textAlign="left" >
                                            <Typography style={{ color: colors.neutral['grey'], fontSize: 'clamp(20px, 3vw, 36px)', lineHeight: "0px", paddingTop: 4, fontWeight: 'bold' }} >
                                                &nbsp;{fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? 'ไม่ตรงแผนผลิต' : fg_tracking_line8?.SKU}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} textAlign="right" >
                                            {fg_tracking_line8?.SHIFT == undefined ? <LightModeOutlinedIcon sx={{ color: '#ffffff', height: 'clamp(10px, 6vh, 100px)', position: "relative", marginTop: { xs: "1vh", md: "12px" } }} /> : fg_tracking_line8?.SHIFT == 'D' ? <LightModeOutlinedIcon sx={{ color: '#ffffff', height: 'clamp(10px, 6vh, 100px)', position: "relative", marginTop: { xs: "1vh", md: "12px" } }} /> : <DarkModeOutlinedIcon sx={{ color: '#ffffff', height: 'clamp(10px, 6vh, 100px)', position: "relative", marginTop: { xs: "1vh", md: "12px" } }} />}
                                        </Grid>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sx={{ position: "relative", marginTop: { xs: "-1vh", md: "-1vh" } }}>
                                    <Grid container spacing={0}>
                                        {/* Block 1: */}
                                        <Grid item xs={4}>
                                            <Box sx={{ backgroundColor: '#404040', p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', }}>
                                                <img src={targetGrey} alt="target" style={{ height: '6vh', objectFit: 'contain', position: "relative", top: isMdUp ? '-0.5vh' : '-1.2vh' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 1, md: 2 } }}>
                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                        {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line8?.TARGET_WEIGHT_KG)).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 2vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                        kg
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Block 2: */}
                                        <Grid item xs={4}>
                                            <Box sx={{ backgroundColor: colors.neutral['green'], p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={Fist} alt="bulb" style={{ height: '6vh', objectFit: 'contain', position: "relative", top: isMdUp ? '-0.5vh' : '-1.2vh' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 1, md: 2 } }}>
                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                        {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line8?.ACTUAL_WEIGHT)).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 2vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                        kg
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Block 3: */}
                                        <Grid item xs={4}>
                                            <Box sx={{ backgroundColor: '#e2e2e2', p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={timeLeft} alt="person" style={{ height: '6vh', objectFit: 'contain', position: "relative", top: isMdUp ? '-0.5vh' : '-1.2vh' }} />
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 1, md: 2 } }}>
                                                    <Typography sx={{ color: '#404040', fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                    {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line8?.REMAINING_WEIGHT <= 0 ? 0 : Math.round(Number(fg_tracking_line8?.REMAINING_WEIGHT)).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: '#636363', fontSize: 'clamp(12px, 2vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                        kg
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={0}>
                                        {/* chart: */}
                                        <Grid item xs={4} sx={{ position: "relative", marginTop: { xs: "5vh", md: "1vh" } }}>
                                            <DonutChartFGTracking
                                                act={fg_tracking_line8?.WARNING == undefined ? 0 : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? 0 : fg_tracking_line8?.ACTUAL_BOX}
                                                diff={fg_tracking_line8?.WARNING == undefined ? 1 : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? 1 : fg_tracking_line8?.REMAINING_BOX < 0 ? 0 : fg_tracking_line8?.REMAINING_BOX}
                                                persent={persent_chart_line8}
                                            />
                                        </Grid>

                                        {/* std/box: */}
                                        <Grid item xs={8} >
                                            <Grid item xs={11} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "1vh", md: "1vh" } }}>
                                                <ItemBox>
                                                    <Grid container spacing={0}>
                                                        {/* Block 1: */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'left', ml: 1 }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                        STD
                                                                    </Typography>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                        /Box
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        {/* Block 2: */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', ml: 1.5 }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(14px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                                        {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line8?.STD_BAG_PER_BOX === 'NA' ? 'NA' : Math.round(Number(fg_tracking_line8?.STD_BAG_PER_BOX)).toLocaleString()}
                                                                    </Typography>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                                        bag
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        {/* Block 3: */}
                                                        <Grid item xs={4}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right', mr: 1 }}>

                                                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                    <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(14px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                                        {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line8?.STD_KG_PER_BOX}
                                                                    </Typography>
                                                                    <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 16px)', ml: 0.5, fontWeight: 'bold' }}>
                                                                        kg
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </ItemBox>
                                            </Grid>
                                            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right', mr: 0.5, position: "relative", marginTop: { xs: "-0.5vh", md: "0vh" } }}>
                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(14px, 2vw, 36px)' }}>
                                                    Box
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "-4vh", md: "-2vh" } }}>
                                                <Grid container spacing={0}>
                                                    {/* target : */}
                                                    <Grid item xs={6}>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                    Target
                                                                </Typography>
                                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: 'bold' }}>
                                                                    {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line8?.TARGET_BOX === 'NA' ? 'NA' : Math.round(Number(fg_tracking_line8?.TARGET_BOX)).toLocaleString()}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>

                                                    {/* actual : */}
                                                    <Grid item xs={6}>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right' }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 36px)' }}>
                                                                    Actual
                                                                </Typography>
                                                                <Typography sx={{ color: '#00ca9b', fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: 'bold' }}>
                                                                    {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line8?.ACTUAL_BOX)).toLocaleString()}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "-4.5vh", md: "-2vh" } }}>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                        <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(12px, 3vw, 28px)' }}>
                                                            Remaining
                                                        </Typography>
                                                        <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: 'bold', ml: 1 }}>
                                                        {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : fg_tracking_line8?.REMAINING_BOX <= 0 ? 0 : Math.round(Number(fg_tracking_line8?.REMAINING_BOX)).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={10} sx={{ ml: 'auto', position: "relative", marginTop: { xs: "-2vh", md: "0vh" } }}>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'right' }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'baseline',
                                                            backgroundColor: 'rgba(255, 165, 0, 0.2)', // สีส้มโปร่งแสง
                                                            px: 1, // padding แนวนอน
                                                            py: 0, // padding แนวตั้ง
                                                            borderRadius: 1,
                                                            height: 'clamp(30px, 8vh, 80px)',
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: colors.neutral['white'],
                                                                fontSize: 'clamp(12px, 3vw, 28px)',
                                                                position: "relative", top: { xs: "-2vh", md: "-.5vh" }
                                                            }}
                                                        >
                                                            Lower ({fg_tracking_line8?.WARNING == undefined ? ('-' + '%') : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line8?.REJECTION_PERCENT)).toLocaleString() + '%'})
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                color: colors.neutral['white'],
                                                                fontSize: 'clamp(28px, 3vw, 42px)',
                                                                fontWeight: 'bold',
                                                                ml: 2,
                                                                position: "relative", top: { xs: "-2vh", md: "-.5vh" }
                                                            }}
                                                        >
                                                            {fg_tracking_line8?.WARNING == undefined ? '-' : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? '-' : Math.round(Number(fg_tracking_line8?.REJECTION_BAG)).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sx={{ borderBottom: "1px solid #c2c2c2", position: "relative", marginTop: { xs: "-11.5vh", md: "3vh" } }} >

                                </Grid>

                                <Grid item xs={12}>
                                    <Grid item xs={12} >
                                        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(10px, 3vw, 38px)', fontWeight: 'bold' }}>
                                                    RM
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(10px, 3vw, 32px)' }}>
                                                    (Batch No.)
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(10px, 3vw, 32px)' }}>
                                                    &
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['white'], fontSize: 'clamp(12px, 3vw, 38px)', fontWeight: 'bold' }}>
                                                    Box Forecast
                                                </Typography>
                                                <Typography sx={{ color: colors.neutral['grey'], fontSize: 'clamp(10px, 3vw, 32px)' }}>
                                                    (Box)
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>

                                </Grid>

                                <Grid item xs={12} sx={{ position: "relative", marginTop: { xs: "-2vh", md: "1vh" } }}>
                                    <Grid container spacing={0.5}>
                                        {(fg_tracking_line8?.WARNING == undefined ? box_box : fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? box_box : slice_ready_line8).map((item) => {
                                            return <Grid item xs={3}>
                                                <Box sx={{ backgroundColor: '#504c4c', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: "5px 5px 0px 0px", height: 'clamp(10px, 7vh, 80px)', }}>
                                                    <Typography sx={{ color: fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? colors.neutral['white'] : (current_batch_line8?.CURRENT_BATCH === '' ? 0 : current_batch_line8?.CURRENT_BATCH) === item.BATCH ? colors.neutral['green'] : colors.neutral['white'], fontSize: 'clamp(16px, 3vw, 36px)', fontWeight: 'bold' }}>
                                                        {item.BATCH}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ backgroundColor: '#404040', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: "0px 0px 5px 5px" }}>
                                                    <img src={box} alt="target" style={{ height: '5vh', objectFit: 'contain' }} />
                                                    <Box sx={{ display: 'flex', alignItems: 'baseline', ml: 0, mt: { xs: 0, md: 0 } }}>
                                                        <Typography sx={{ color: fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? colors.neutral['white'] : (current_batch_line8?.CURRENT_BATCH === '' ? 0 : current_batch_line8?.CURRENT_BATCH) === item.BATCH ? colors.neutral['green'] : colors.neutral['white'], fontSize: 'clamp(18px, 3vw, 36px)', fontWeight: 'bold', ml: 0.5 }}>
                                                            {fg_tracking_line8?.WARNING == 'ไม่ตรงแผนผลิต' ? item.BARREL_MEAT : Math.floor((((fg_tracking_line8?.FG_STD_PERCENT_MEAT_YIELD == undefined ? 0 : fg_tracking_line8?.FG_STD_PERCENT_MEAT_YIELD) * item.BARREL_MEAT) / 100) / (fg_tracking_line8?.STD_KG_PER_BOX == undefined ? 0 : fg_tracking_line8?.STD_KG_PER_BOX)).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        })
                                        }
                                    </Grid>
                                </Grid>
                            </Item>}
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default FGTrackingLine7Line8
